import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { NavigationCustomizationDialogComponent } from './navigation-customization-dialog.component';
import { TranslationModule } from '@core/translation/translation.module';
import { NavigationSharedModule } from '@modules/bcm/user-settings/navigation/navigation-shared.module';
import { ScrollingModule } from '@angular/cdk/scrolling';

@NgModule({
    declarations: [
        NavigationCustomizationDialogComponent,
    ],
    imports: [
        MatDialogModule,
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        FlexLayoutModule,
        TranslationModule,
        NavigationSharedModule,
        ScrollingModule,
    ],
    exports: [
        NavigationCustomizationDialogComponent,
    ],
})
export class NavigationCustomizationDialogModule {
}
